import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Header } from './features/shared/components/Header';
import { LandingPage } from './features/coordinator/pages/LandingPage';
import { NewSession } from './features/coordinator/pages/NewSession';
import { SessionDetails } from './features/coordinator/pages/SessionDetails';
import { AuthGuard } from './features/auth/components/AuthGuard';
import { mentorRoutes } from './features/mentor/routes';
import { menteeRoutes } from './features/mentee/routes';
import { authRoutes } from './features/auth/routes';

function App() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="container mx-auto px-4 py-8">
        <Routes>
          {/* Public routes */}
          {authRoutes}
          
          {/* Protected routes wrapper */}
          <Route element={<AuthGuard />}>
            {/* Default redirect */}
            <Route index element={<Navigate to="/coordinator" replace />} />
            
            {/* Coordinator routes */}
            <Route path="coordinator">
              <Route index element={<LandingPage />} />
              <Route path="new/session" element={<NewSession />} />
              <Route path="session/:id" element={<SessionDetails />} />
            </Route>
            
            {/* Mentor routes */}
            <Route path="mentor/*">
              {mentorRoutes}
            </Route>
            
            {/* Mentee routes */}
            <Route path="mentee/*">
              {menteeRoutes}
            </Route>
          </Route>
        </Routes>
      </main>
    </div>
  );
}

export default App;